import { defineMessages } from 'react-intl';

export const messages: {
	heading: {
		id: string;
		defaultMessage: string;
		description: string;
	};
	discoverButton: {
		id: string;
		defaultMessage: string;
		description: string;
	};
} = defineMessages({
	heading: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.cli-and-code-review.heading',
		defaultMessage: 'AI for software teams, now live in your terminal and source code app',
		description:
			'Heading displayed in the Rovo Dev adoption in-product message in the Jira side navigation. This generic variant promotes both CLI and Code Review capabilities together, highlighting availability in terminal and IDE/source code environments.',
	},
	discoverButton: {
		id: 'jolt.jira-side-nav-rovo-dev-adoption-ipm.cli-and-code-review.discover-button',
		defaultMessage: 'Discover Rovo Dev',
		description:
			'Label for the primary call-to-action button in the Rovo Dev adoption in-product message displayed in the Jira side navigation. Invites users to learn more about and start using Rovo Dev.',
	},
});
